'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:ProfileDetailsCtrl
 * @description
 * # ProfileDetailsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('ProfileDetailsCtrl', function($http, $window, $location,
    cfpLoadingBar, Upload, profileService, eventsService, FlashService) {


    var profileDetailsVm = this;
    profileDetailsVm.properties = {
      previewMode: false
    };
    profileDetailsVm.croppedDataUrl = '';
    profileDetailsVm.profileData = {
      firstName: null,
      lastName: null,
      nickname: null,
      picFile: undefined
    };

    profileDetailsVm.updateProfile = updateProfile;
    profileDetailsVm.preview = previewImage;
    profileDetailsVm.refresh = activate;

    activate();

    function activate() {
      return getUserProfile()
      .then(requestComplete);
    }

    function getUserProfile() {
      requestStart();
      return profileService.getUserProfile()
      .then(function(response) {
        response.profilePictureUrl = !!response.profilePictureUrl ? response.profilePictureUrl : '/images/ui-sam.jpg';
        profileDetailsVm.user = response;
        profileDetailsVm.profileData.firstName = angular.copy(response.firstName);
        profileDetailsVm.profileData.lastName = angular.copy(response.lastName);
        profileDetailsVm.profileData.nickname = angular.copy(response.nickname);
      })
      .finally(requestComplete);
    }

    function updateProfile() {
      requestStart();
      var file = !!profileDetailsVm.profileData.picFile ?
                  Upload.dataUrltoBlob(profileDetailsVm.croppedDataUrl, profileDetailsVm.profileData.picFile.name) :
                  null;
      profileDetailsVm.profileData.profilePictureFile = file;
      var profileData = {
        firstName: profileDetailsVm.profileData.firstName,
        lastName: profileDetailsVm.profileData.lastName,
        nickname: profileDetailsVm.profileData.nickname,
        profilePictureFile: file
      };
      var url = profileService.updateUserProfileUrl();
      return Upload.upload({
            url: url,
            method: 'PUT',
            data: profileData
        })
      .then(function(response) {
        eventsService.profileUpdated();
        clearAttachedFile();
        profileDetailsVm.refresh();
        FlashService.Success('Profile updated');
      })
      .catch(responseError)
      .finally(requestComplete);
    }

    function previewImage() {
      if (profileDetailsVm.properties.previewMode) {
        profileDetailsVm.user.profilePictureUrl = profileDetailsVm.originalPictureUrl;
        profileDetailsVm.properties.previewMode = false;
      } else if (!!profileDetailsVm.profileData.picFile) {
        profileDetailsVm.originalPictureUrl = angular.copy(profileDetailsVm.user.profilePictureUrl);
        profileDetailsVm.properties.previewMode = true;
        profileDetailsVm.user.profilePictureUrl = profileDetailsVm.croppedDataUrl;
      }
    }

    function clearAttachedFile() {
      profileDetailsVm.profileData.picFile = undefined;
      profileDetailsVm.croppedDataUrl = '';
    }

    function responseError(error) {
      FlashService.Error('Network Error. Try reloading the page', false);
    }

    function requestComplete() {
      profileDetailsVm.inprogress = false;
      cfpLoadingBar.complete();
    }

    function requestStart() {
      cfpLoadingBar.start();
      profileDetailsVm.inprogress = true;
    }



    return profileDetailsVm;
  });
